export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 15.25h6a.75.75 0 010 1.5H5A2.75 2.75 0 012.25 14V7A2.75 2.75 0 015 4.25h2.333A2.417 2.417 0 019.75 6.667c0 .046.037.083.083.083H16a2.75 2.75 0 012.75 2.75v.5a.75.75 0 01-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25H9.833A1.583 1.583 0 018.25 6.667a.917.917 0 00-.917-.917H5c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25zM18.75 13a.75.75 0 00-1.5 0v2.25H15a.75.75 0 000 1.5h2.25V19a.75.75 0 001.5 0v-2.25H21a.75.75 0 000-1.5h-2.25V13z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};